import {
  getListPageSuccessNewData,
  getListPageSuccessNewLinks,
} from 'reducers/utils';

import {
  LOAD_DEVICE_NAMES_START,
  LOAD_DEVICE_NAMES_SUCCESS,
  LOAD_DEVICE_NAMES_FAIL,
  ADD_DEVICE_NAME_SUCCESS,
  ADD_DEVICE_NAME_FAIL,
  ADD_DEVICE_NAME_RESET,
} from 'actions/devices';

import {
  SEARCH_DEVICE_NAMES_LIST_PAGE_SUCCESS,
  SEARCH_DEVICE_NAMES_LIST_PAGE_FAIL,
  SEARCH_DEVICE_NAMES_LIST_PAGE_START,
  DELETE_DEVICE_NAME_SUCCESS,
  DELETE_DEVICE_NAME_FAIL,
  GET_DEVICES_USING_DEVICE_NAMES_COUNT_SUCCESS,
  GET_DEVICES_USING_DEVICE_NAMES_COUNT_FAIL,
  UPDATE_DEVICE_NAME_START,
  UPDATE_DEVICE_NAME_SUCCESS,
  UPDATE_DEVICE_NAME_FAIL,
  CLEAR_UPDATE_DEVICE_NAME,
} from 'actions/deviceNamesList';

export const defaultState = {
  loading: true,
  data: [],
  links: {},
  totalDevices: 0,
  error: false,
  added: null,
  updated: {
    deviceName: null,
    error: null,
  },
};

export default function deviceNames(state = defaultState, action) {
  switch (action.type) {
    case LOAD_DEVICE_NAMES_START: {
      return {
        ...state,
        loading: true,
        error: false,
        added: null,
      };
    }
    case LOAD_DEVICE_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    case LOAD_DEVICE_NAMES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case ADD_DEVICE_NAME_SUCCESS: {
      return {
        ...state,
        added: action.payload,
      };
    }
    case ADD_DEVICE_NAME_FAIL: {
      return {
        ...state,
        error: true,
      };
    }
    case ADD_DEVICE_NAME_RESET: {
      return {
        ...state,
        error: false,
        loading: false,
        added: null,
      };
    }
    case UPDATE_DEVICE_NAME_START:
      return {
        ...state,
        updated: {
          deviceName: null,
          error: null,
        },
      };
    case UPDATE_DEVICE_NAME_SUCCESS: {
      return {
        ...state,
        updated: {
          deviceName: action.payload,
          error: false,
        },
      };
    }
    case UPDATE_DEVICE_NAME_FAIL: {
      return {
        ...state,
        updated: {
          deviceName: null,
          error: action.payload,
        },
      };
    }
    case CLEAR_UPDATE_DEVICE_NAME: {
      return {
        ...state,
        updated: {
          ...defaultState.updated,
        },
      };
    }
    case SEARCH_DEVICE_NAMES_LIST_PAGE_START: {
      return {
        ...state,
        loading: true,
        error: false,
        updated: {
          ...defaultState.updated,
        },
      };
    }
    case SEARCH_DEVICE_NAMES_LIST_PAGE_SUCCESS: {
      const { data, links, total } = action.payload;
      return {
        ...state,
        total,
        loading: false,
        data: getListPageSuccessNewData(state, data, links),
        links: getListPageSuccessNewLinks(links),
      };
    }
    case GET_DEVICES_USING_DEVICE_NAMES_COUNT_SUCCESS: {
      const { count } = action.payload;
      return {
        ...state,
        totalDevices: count,
      };
    }
    case DELETE_DEVICE_NAME_SUCCESS: {
      return {
        ...state,
        loading: true,
        data: [], // Require reload
      };
    }
    case DELETE_DEVICE_NAME_FAIL: {
      const newState = { ...state };
      if (action?.payload.code === 504) {
        newState.data = []; // xmApi timeout, require reload
      } else {
        newState.error = true;
      }
      return newState;
    }
    case GET_DEVICES_USING_DEVICE_NAMES_COUNT_FAIL:
    case SEARCH_DEVICE_NAMES_LIST_PAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
